import { createFileRoute } from "@tanstack/solid-router";
import { useAuth } from "~/lib/auth";

export const Route = createFileRoute("/auth/login")({
  component: LoginPage,
});

function LoginPage() {
  const auth = useAuth();

  return (
    <div class="login-bg min-h-screen flex items-center justify-center p-4">
      <div class="w-full max-w-sm">
        {/* Logo + wordmark */}
        <div class="flex flex-col items-center mb-8">
          <img src="/logo.png" alt="Reliquo logo" class="h-16 w-16 mb-4" />
          <h1 class="text-2xl font-semibold tracking-tight text-foreground">
            Reliquo
          </h1>
          <p class="text-sm text-muted-foreground mt-1">
            Your genealogy platform
          </p>
        </div>

        {/* Auth card */}
        <div class="bg-card border border-border rounded-xl p-8 shadow-sm">
          <h2 class="text-lg font-medium text-foreground mb-1">Welcome back</h2>
          <p class="text-sm text-muted-foreground mb-6">
            Sign in to your account to continue
          </p>

          <button
            type="button"
            onClick={() => auth.login()}
            class="w-full h-10 px-4 rounded-lg bg-primary text-primary-foreground text-sm font-medium
                   hover:bg-primary/90 transition-colors duration-150 focus-visible:outline-none
                   focus-visible:ring-2 focus-visible:ring-ring"
          >
            Sign in
          </button>

          <div class="relative my-5">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-border" />
            </div>
            <div class="relative flex justify-center">
              <span class="bg-card px-3 text-xs text-muted-foreground">or</span>
            </div>
          </div>

          <button
            type="button"
            onClick={() => auth.register()}
            class="w-full h-10 px-4 rounded-lg border border-border bg-transparent text-sm font-medium
                   text-foreground hover:bg-muted/50 transition-colors duration-150
                   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            Create an account
          </button>
        </div>
      </div>
    </div>
  );
}
